export default __webpack_public_path__ + "static/media/team-3.5d536a7c.jpg";